import type { IconData } from '@stacksjs/iconify-core'

export const paragraph: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 2v11a1 1 0 0 1-2 0V2H8v11a1 1 0 0 1-2 0V8H4a4 4 0 1 1 0-8h9a1 1 0 0 1 0 2zM6 6V2H4a2 2 0 1 0 0 4z\"/>",
  "width": 14,
  "height": 14,
  "viewBox": "0 0 14 14"
}

export default paragraph
